export function validatePassword(password) {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})");
    var mediumRegex = new RegExp("^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})");


    if (strongRegex.test(password)) {
        return "strong";
    }
    
    if (mediumRegex.test(password)) {
        return "medium";
    }

    return "weak";
}


export function validatePasswordWrapper(password) {
    if (validatePassword(password) === "weak") {
        return {
            valid: false,
            message: "Password too weak"
        }
    }

    return {valid: true};
}


export function validateEmail(email) {
    if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/.test(email)) {
        return true;
    }
    
    return false;
}


export function validateEmailWrapper(email) {
    if (validateEmail(email)) {
        return {
            valid: true
        }
    }
    else {
        return {
            valid: false,
            message: "Please insert a valid email"
        }
    }
}

export function validateRequiredField(label, value) {
    if (value.length > 0) {
        return {
            valid: true
        }
    }
    else {
        return {
            valid: false,
            message: label + " is required"
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/utils/form.js